import { colors } from "constants/colors";
import styled, { css } from "styled-components";
import { newColors } from "constants/newColors";
import { TextWithIconButton } from "components/parts/Button/TextWithIconButton";

export const StyledHeadline = styled.div`
  display: flex;
  align-items: center;
  height: 4.5rem;
  column-gap: 0.5rem;
`;

export const ScnerioCardContainer = styled.div`
  display: flex;
  height: calc(100% - 6.5rem);
  flex-grow: 1;
  width: 100%;
  justify-content: space-between;
  column-gap: 2rem;
  box-sizing: border-box;
`;

export const StyledScenarioTextArea = styled.textarea`
  background: ${newColors.white};
  font-size: 14px;
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  resize: none;

  box-sizing: border-box;
  border: solid 1px ${newColors.border};
  border-radius: 5px;
  padding: 1rem;
  box-shadow: 0px 0px 5px ${colors.lightGray};

  &:disabled {
    background: ${colors.disable};
  }

  &:focus {
    background: ${colors.form.focused};
  }
`;

export const StyledLeftArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 50%;
  gap: 0.5rem;
`;

export const StyledRightArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 50%;
  gap: 0.5rem;
`;

export const StyledTextWithIconButton = styled(TextWithIconButton)`
  flex-direction: row;
  margin-right: 1rem;
  margin-left: auto;
`;

export const StyledScenarioPreview = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  box-sizing: border-box;
  background: ${newColors.white};
  border: solid 1px ${newColors.border};
  border-radius: 5px;
  padding: 1rem;
  box-shadow: 0px 0px 5px ${colors.lightGray};
`;

type StyledTitleAreaProps = {
  minHeight?: string;
};

export const StyledTitleArea = styled.div<StyledTitleAreaProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  ${({ minHeight }) =>
    minHeight &&
    css`
      min-height: ${minHeight};
    `}

  span:first-child {
    margin-inline: auto;
  }
`;

export const StyledUl = styled.ul`
  display: flex;
  align-items: center;
  margin-right: auto;
  flex-wrap: wrap;
  box-sizing: border-box;
  gap: 0.5rem 1.5rem;
  padding-inline: 1rem;
  min-height: 35px;
`;

export const StyledLi = styled.li``;
